// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
 /* Adding scroll to the MyCourses Card */
 .Content
{
  height:200px;
   overflow:auto;
    background:#fff;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_varables.css"],"names":[],"mappings":";CACC,wCAAwC;CACxC;;EAEC,YAAY;GACX,aAAa;IACZ,eAAe;AACnB","sourcesContent":["\n /* Adding scroll to the MyCourses Card */\n .Content\n{\n  height:200px;\n   overflow:auto;\n    background:#fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
